import React, {
  useEffect,
  useContext,
  useState,
  useRef,
  forwardRef,
} from "react";
import PatientContext from "../../../context/PatientContext";
import "./index.css";
import ReactToPrint from "react-to-print";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import ProtocolTable from "./ProtocolTable";
import Disclaimer from "./Disclaimer";

const PrintPdfDetails = forwardRef((props, ref) => {
  const [patientInfo, setPatientInfo] = useState(props.PdfInfo);
  const { contextPatientReport } = useContext(PatientContext);
  const { patientDetails } = useContext(PatientContext);
  const [units, setUnits] = useState(props.units);

  const [apidata, setAPI] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    setPatientInfo(props.PdfInfo);
    setUnits(props.units);
    const report = contextPatientReport.data;
    setAPI({
      referralToConsultant: report.referral_to_consultant,
      next_steps: report.next_steps,
      risk: report.risk,
      score: report.score,
      testsFollowUp: report.tests_follow_up,
      treatmentGoals: report.treatment_goals,
      labInvestigation: report.lab_investigation,
      educate: report.educate_on,
      diagnostics_imaging: report.diagnostics_imaging,
      risk_text: report.risk_text,
    });
  }, [patientDetails, props.PdfInfo, contextPatientReport, props.units]);

  let riskCardColor = "";

  riskCardColor = !apidata
    ? "risk-low-color"
    : apidata.risk === "High Risk"
    ? "risk-high-color"
    : apidata.risk === "Moderate Risk" || apidata.risk === "Medium Risk"
    ? "risk-medium-color"
    : "risk-low-color";

  const loginDetails = JSON.parse(Cookies.get("login_details"));

  const renderFooter = (pageNumber, totalPage) => (
    <footer className="pdf-footer-container">
      <div className="pdf-footer-row">
        <div className="pdf-footer-left">
          <p className="footer-text mb-4">
            Accessed &amp; utilized by{" "}
            <span className="text-capital">{loginDetails.executive}</span>
          </p>
        </div>
        <p className="footer-text pdf-footer-page">
          Page {pageNumber} of {totalPage}
        </p>
      </div>
      <div className="style-line-container">
        <div className="line-1"></div>
        <div className="line-2"></div>
      </div>
    </footer>
  );

  const renderHeader = () => (
    <div className="page-header">
      <h1 className="header-heading">Participant Report</h1>
      <img
        className="header-log"
        src="./apollo-white-logo.png"
        alt="apollo-logo"
      />
    </div>
  );

  // Each entry is the content of one page. Page numbers are derived from this list.
  const pages = [];

  pages.push(
    <div className="pdf-content-container">
      <ul className="pdf-user-info-container">
        {Object.entries(patientInfo?.basic_info).map(([key, value]) => (
          <li key={key}>
            <p className="pdf-user-info-heading">{key}</p>:
            <p className="pdf-user-info-value">{value||'NA'}</p>
          </li>
        ))}
      </ul>
      <p className="line"></p>
      <h1 className="pdf-sub-heading">
        APOLLO HOSPITALS THANK YOU FOR YOUR CONSENT
      </h1>
      <p className="pdf-page-text">
        Based on current parameters, personal &#38; family history, AI enabled
        tools derive health risk scores to alert participant on his/her likely
        predisposition to a disease to aid early detection &#38; early medical
        intervention to mitigate the risk.
      </p>
      <div className="details-container">
        <h2 className="details-header">PAST HISTORY</h2>
        <ul className="details-grid">
          {Object.entries(patientInfo["Past History"]).map(([key, value]) => (
            <li key={key} className="details-item">
              <p className="details-key">{key}</p>
              <p className="details-value">{value||'NA'}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="details-container heart-health-container">
        <h2 className="details-header heart-health-header">MEDICAL HISTORY</h2>
        <ul className="details-grid">
          {Object.entries(patientInfo["Medical History"]).map(
            ([key, value]) => (
              <li key={key} className="details-item">
                <p className="details-key">
                  {key} {units[key] && `(${units[key]})`}
                </p>
                <p className="details-value heart-health-value">{value||"NA"}</p>
              </li>
            )
          )}
        </ul>
      </div>
    </div>
  );

  pages.push(
    <div className="pdf-content-container">
      <div className="pdf-new-report-card pdf-report-margin-top">
        <h2 className="pdf-report-card-title">
          AI Calculated Risk Score Based on Your Inputs
        </h2>
        {apidata && (
          <div className="pdf-risk-section">
            <div className="pdf-copd-risk-cards">
              <div className="pdf-risk-card">
                <h3 className="pdf-risk-card-title">Risk Status</h3>
                <div className={`${riskCardColor} pdf-risk-highlight`}>
                  {apidata.risk}
                </div>
              </div>
              <div className="pdf-risk-card">
                <h3 className="pdf-risk-card-title">Risk Score</h3>
                <p className={`pdf-risk-value`}>{apidata.risk_text}</p>
              </div>
            </div>
          </div>
        )}
      </div>
       <div className="pdf-new-report-card pdf-report-margin-top">
        <h2 className="report-card-title">AI Recommended Protocol</h2>
        {apidata && <ProtocolTable data={apidata} />}
      </div>
    </div>
  );



  pages.push(
    <div className="pdf-content-container">
      <div className="pdf-new-report-card pdf-report-margin-top">
        <h2 className="report-card-title">Disclaimer</h2>
        <Disclaimer />
      </div>
    </div>
  );

  return (
    <div className="pdf-container" ref={ref}>
      {pages.map((content, index) => (
        <div className="page" key={index}>
          {renderHeader()}
          {content}
          {renderFooter(index + 1, pages.length)}
        </div>
      ))}
    </div>
  );
});

const COPDPdfDetails = (props) => {
  const componentRef = useRef();
  const navigate = useNavigate();

  const gotohome = () => {
    navigate("/");
  };

  return (
    <div className="pdf-report-button">
      <PrintPdfDetails
        ref={componentRef}
        PdfInfo={props.PdfInfo}
        units={props.units}
      />
      <div className="report-buttons-container">
        <button className="download-btn home-button" onClick={gotohome}>
          <img className="home-icon" src="./home-icon.svg" alt="download.svg" />
        </button>
        <ReactToPrint
          trigger={() => (
            <button className="download-btn download-button">
              <img
                className="download-icon"
                src="./cloud-download-outline.svg"
                alt="download.svg"
              />
            </button>
          )}
          content={() => componentRef.current}
        />
      </div>
    </div>
  );
};

export default COPDPdfDetails;
